/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
// import Icon from "@mui/material/Icon";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKAvatar from "components/MKAvatar";
// import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";

// Images
import companyLogo from "assets/images/gants.jpg";

function Profile() {
  return (
    <MKBox component="section" py={{ xs: 6, sm: 12 }}>
      <Container>
        {/* <Grid container item xs={12} justifyContent="center" mx="auto">
          <MKBox mt={{ xs: -16, md: -20 }} textAlign="center">
            <MKAvatar src={profilePicture} alt="Burce Mars" size="xxl" shadow="xl" />
          </MKBox>
          <Grid container justifyContent="center" py={6}>
            <Grid item xs={12} md={7} mx={{ xs: "auto", sm: 6, md: 1 }}>
              <MKBox display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                <MKTypography variant="h3">Michael Roven</MKTypography>
                <MKButton variant="outlined" color="info" size="small">
                  Follow
                </MKButton>
              </MKBox>
              <Grid container spacing={3} mb={3}>
                <Grid item>
                  <MKTypography component="span" variant="body2" fontWeight="bold">
                    323&nbsp;
                  </MKTypography>
                  <MKTypography component="span" variant="body2" color="text">
                    Posts
                  </MKTypography>
                </Grid>
                <Grid item>
                  <MKTypography component="span" variant="body2" fontWeight="bold">
                    3.5k&nbsp;
                  </MKTypography>
                  <MKTypography component="span" variant="body2" color="text">
                    Followers
                  </MKTypography>
                </Grid>
                <Grid item>
                  <MKTypography component="span" variant="body2" fontWeight="bold">
                    260&nbsp;
                  </MKTypography>
                  <MKTypography component="span" variant="body2" color="text">
                    Following
                  </MKTypography>
                </Grid>
              </Grid>
              <MKTypography variant="body1" fontWeight="light" color="text">
                Decisions: If you can&apos;t decide, the answer is no. If two equally difficult
                paths, choose the one more painful in the short term (pain avoidance is creating an
                illusion of equality). Choose the path that leaves you more equanimous. <br />
                <MKTypography
                  component="a"
                  href="#"
                  variant="body1"
                  fontWeight="light"
                  color="info"
                  mt={3}
                  sx={{
                    width: "max-content",
                    display: "flex",
                    alignItems: "center",

                    "& .material-icons-round": {
                      transform: `translateX(3px)`,
                      transition: "transform 0.2s cubic-bezier(0.34, 1.61, 0.7, 1.3)",
                    },

                    "&:hover .material-icons-round, &:focus .material-icons-round": {
                      transform: `translateX(6px)`,
                    },
                  }}
                >
                  More about me <Icon sx={{ fontWeight: "bold" }}>arrow_forward</Icon>
                </MKTypography>
              </MKTypography>
            </Grid>
          </Grid>
        </Grid> */}
        <Grid container item xs={12} justifyContent="center" mx="auto">
  <MKBox mt={{ xs: -16, md: -20 }} textAlign="center">
    <MKAvatar src={companyLogo} alt="CamerClean" size="xxl" shadow="xl" />
  </MKBox>
  <Grid container justifyContent="center" py={6}>
    <Grid item xs={12} md={7} mx={{ xs: "auto", sm: 6, md: 1 }}>
      <MKBox display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        <MKTypography variant="h3">CamerClean</MKTypography>
        {/* <MKButton variant="outlined" color="info" size="small">
          Demander un devis
        </MKButton> */}
      </MKBox>
      <MKTypography variant="body1" fontWeight="light" color="text">
        CamerClean est une entreprise spécialisée dans le nettoyage professionnel de bureaux et de
        domiciles. Nous garantissons des prestations de haute qualité, adaptées aux besoins de nos
        clients. Faites confiance à notre équipe expérimentée pour un environnement propre et
        sain.
      </MKTypography>
      {/* <MKTypography
        component="a"
        href="/services"
        variant="body1"
        fontWeight="light"
        color="info"
        mt={3}
        sx={{
          width: "max-content",
          display: "flex",
          alignItems: "center",
          "& .material-icons-round": {
            transform: `translateX(3px)`,
            transition: "transform 0.2s cubic-bezier(0.34, 1.61, 0.7, 1.3)",
          },
          "&:hover .material-icons-round, &:focus .material-icons-round": {
            transform: `translateX(6px)`,
          },
        }}
      >
        En savoir plus <Icon sx={{ fontWeight: "bold" }}>arrow_forward</Icon>
      </MKTypography> */}
    </Grid>
  </Grid>
</Grid>

      </Container>
    </MKBox>
  );
}

export default Profile;
